import { IInventoryPage } from '../../inventory-page.interface';


export const USER_SIGN_UP_PAGE: IInventoryPage = {
	'route': '/user/sign-up',
	'title': 'Signup',
	'uiReference': [
		'Start with Flying',
		'Create one secure account for Flying Research and Flying Upload.',
		'Enter first name',
		'Enter last name',
		'Enter email',
		'Create password',
		'Repeat password',
		'First name',
		'Please enter your first name.',
		'Last name',
		'Please enter your last name.',
		'Email',
		'Please enter a valid email.',
		'Password',
		'Use at least 8 characters with uppercase, lowercase, a number, and a special character.',
		'Confirm password',
		'The passwords do not match.',
		'I agree to the Terms of Use and Privacy Policy .',
		'I agree to receive product news and account-related emails.',
		'Create account',
		'Already have an account? Sign in',
		'Flying account sign in',
		'Appearance',
		'One secure account for Flying Research and Flying Upload'
	],
	'sources': [
		'apps/flying-projects/frontend/webapp/src/app/pages/public/auth/auth-routing.module.ts',
		'apps/flying-projects/frontend/webapp/src/app/pages/public/auth/signup/signup.component.ts',
		'apps/flying-projects/frontend/webapp/src/app/pages/public/auth/signup/signup.component.html',
		'apps/flying-projects/frontend/webapp/src/app/pages/public/auth/auth-shell/auth-shell.component.ts',
		'apps/flying-projects/frontend/webapp/src/app/pages/public/auth/auth-shell/auth-shell.component.html'
	]
};
